import React, { forwardRef, ButtonHTMLAttributes } from 'react';
import cn from 'classnames';
import styles from './IconButton.scss';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  type?: 'submit' | 'reset' | 'button';
}

export const IconButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ type = 'button', className, ...props }, ref) => (
    <button
      type={type}
      className={cn(styles.button, className)}
      {...props}
      ref={ref}
    />
  ),
);
export default IconButton;
